import {Center, CenterProps, Stack, Text} from "@mantine/core";
import {ReactNode} from "react";

export type EmptyProps = Omit<CenterProps, 'children'> & {
    message: string
    action?: ReactNode
}

export const Empty = (props: EmptyProps) => {
    const {message, action, ...rest} = props
    return (
        <Center {...rest}>
            <Stack>
                <Text align="center">
                    {message}
                </Text>
                {action}
            </Stack>
        </Center>
    )
}
